import React from 'react';

export function Card({ children }) {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      {children}
    </div>
  );
}

export function CardHeader({ children }) {
  return (
    <div className="mb-4">
      {children}
    </div>
  );
}

export function CardTitle({ children }) {
  return (
    <h2 className="text-xl font-bold">
      {children}
    </h2>
  );
}

export function CardContent({ children }) {
  return (
    <div>
      {children}
    </div>
  );
}

export { Card as default };